import servicio from '@/services/servicio-base'

const servicioInicio = {}

servicioInicio.getBanners = function(p1, p2){
    return servicio.get(`/banners/controlbannersobtener/${p1}/${p2}`)
        .then(r => {
            return r.data
        })
        .catch(err => {
            return err
        })
}

servicioInicio.obtenerPopUp = function(codCliente){
    return servicio.get(`/banners/pup-up/${codCliente}`)
        .then(r => {
            return r.data
        })
        .catch(err => {
            return err
        })
}

servicioInicio.registrarClickPublicidad =  params => {
    return servicio.post('/banners/registrar-click-publicidad/', params)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioInicio.obtenerArticulosRelacionados = function(IdPublicidad, TipoPublicidad){
    return servicio.get(`/banners/publicidad/obtener-articulos-relacionados/${IdPublicidad}/${TipoPublicidad}`)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}


export default servicioInicio

